import { render, staticRenderFns } from "./PotsDetail.vue?vue&type=template&id=71fa766a&"
import script from "./PotsDetail.vue?vue&type=script&lang=js&"
export * from "./PotsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports